import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { apiCallDebounceTime } from '../../Constants/Api';
import { debounce } from 'throttle-debounce';
import { setResultsPageSearchTerm } from '../../redux/actions/resultsActions';
import TextField from '@material-ui/core/TextField';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useHistory } from 'react-router-dom';
import { Results_NavLink_To } from '../../Constants/AppBar';
import { Search as SearchIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
	searchTxtField: {
		width: '100%',
	},
}));

const Search = (props) => {
	const searchTerm = useSelector((state) => state.resultsSearchTerm);
	const dispatch = useDispatch();
	const history = useHistory();
	const classes = useStyles();

	// implementing debounce for results search.
	const DebounceResultsSearch = useCallback(
		debounce(apiCallDebounceTime, false, (searchTerm) => {
			// navigating user to search results page, when user types an input in the search box of results page.
			// Encode search term before adding it as a param to URL.
			history.push({
				pathname: Results_NavLink_To + '/' + encodeURIComponent(searchTerm),
			});
		}),
		[],
	);

	const handleTextFieldOnChange = (event) => {
		const searchTerm = event.target.value;
		if (searchTerm !== null && typeof searchTerm !== undefined) {
			dispatch(setResultsPageSearchTerm(searchTerm, { ...history }));
			DebounceResultsSearch(searchTerm);
		}
	};
	return (
		<TextField
			id="results-search"
			data-cy="results-search"
			variant="outlined"
			type="search"
			key="searchField"
			value={searchTerm}
			className={classes.searchTxtField}
			onChange={handleTextFieldOnChange}
			placeholder={'search corgis... '}
			autoComplete="off"
			InputProps={{
				startAdornment: <SearchIcon />,
			}}
		/>
	);
};

export default Search;
